import {Component} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-eula',
  imports: [],
  templateUrl: './eula.component.html',
  styleUrls: ['./eula.component.scss'],
  standalone: true
})
export class EulaComponent {
  constructor(public activeModal: NgbActiveModal) {}

  /* istanbul ignore next */
  acceptEula() {
    this.activeModal.close('accepted');
  }

  /* istanbul ignore next */
  openEula() {
    window.open(`${environment.geoTabURL}/assets/files/EULA.pdf`, '_blank');
  }
}
